// System
import { Button, Typography } from '@mui/material';

// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';

// Hooks
import { useRaindropsTable } from '@Modal/hooks/raindrop/useRaindropsTable';

export const CancelRaindropModalDialog = () => {
  const { isCancelRaindropModalOpen, handleCloseCancelRaindropModal, handleCancelRaindrop } =
    useRaindropsTable();

  return (
    <ClosableModal
      name="CancelRaindropModalDialog"
      title="Cancel Raindrop"
      open={isCancelRaindropModalOpen}
      onClose={handleCloseCancelRaindropModal}
      sx={{ width: '592px' }}
    >
      <CreateDialogLayout>
        <Typography variant="body1"> Are you sure you want to cancel this raindrop?</Typography>
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleCloseCancelRaindropModal}>
              Reject
            </Button>
          </AtLocator>
          <Button variant="contained" color="error" onClick={handleCancelRaindrop}>
            Confirm
          </Button>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </ClosableModal>
  );
};
